import { createContext, useContext } from "react";

import { PatientRecordScreenHelper } from "./PatientRecordScreenHelper.ts";

export const PatientRecordScreenContext =
  createContext<PatientRecordScreenHelper>({} as PatientRecordScreenHelper);

export const usePatientRecordScreenContext = () =>
  useContext(PatientRecordScreenContext);
